module.exports = __webpack_public_path__ + "static/media/SangBleuSans-Light-WebS.11bb4a47.woff";